import {ResponsivePie} from '@nivo/pie'
import React from 'react'
import {number} from 'prop-types'

interface Data {
  id: string
  label: string
  value: number
  color: string
}

interface Props {
  data: Data[]
}

export const OhHangPieChart: React.FC<Props> = ({data}) => (
  <ResponsivePie
    data={data}
    margin={{top: 40, right: 80, bottom: 40, left: 80}}
    innerRadius={0.6}
    padAngle={0.7}
    cornerRadius={3}
    colors={[
      'rgb(0,0,255)',
      'rgb(255,0,0)',
      'rgb(255,198,22)',
      'rgb(225,225,225)',
      'rgb(46,46,46)',
    ]}
    borderWidth={1}
    // @ts-ignore
    borderColor={{from: 'color', modifiers: [['darker', '0.5']]}}
    radialLabelsSkipAngle={10}
    radialLabelsTextColor="#333333"
    radialLabelsLinkColor={{from: 'color'}}
    radialLabelsLinkStrokeWidth={2}
    enableSliceLabels={false}
    sliceLabelsSkipAngle={10}
    sliceLabelsTextColor="#333333"
    isInteractive={false}
    defs={[
      {
        id: 'dots',
        type: 'patternDots',
        background: 'inherit',
        color: 'rgba(255,255,255,0)',
        size: 4,
        padding: 1,
        stagger: true,
      },
      {
        id: 'lines',
        type: 'patternLines',
        background: 'inherit',
        color: 'rgba(255, 255, 255, 0.3)',
        rotation: -45,
        lineWidth: 6,
        spacing: 10,
      },
    ]}
    // fill={[
    //   {
    //     match: {
    //       id: '물'
    //     },
    //     id: 'lines'
    //   },
    //
    //   {
    //     match: {
    //       id: '쇠'
    //     },
    //     id: 'dots'
    //   },
    //
    // ]}
  />
)

export function getOhHangPieData(val: number, i: number): Data {
  const colors = [
    'rgb(86,133,255)',
    'rgb(255,93,88)',
    'rgb(255,198,22)',
    'rgb(239,239,239)',
    'rgb(117,117,117)',
  ]
  const ids = ['나무', '불', '흙', '쇠', '물']
  const labels = ['나무', '불', '흙', '쇠', '물']
  return {
    id: ids[i],
    label: labels[i],
    value: val,
    color: colors[i],
  }
}

export function transformOhHangData(input: number[]): Data[] {
  const colors = [
    'rgb(86,133,255)',
    'rgb(255,93,88)',
    'rgb(255,198,22)',
    'rgb(239,239,239)',
    'rgb(117,117,117)',
  ]
  const ids = ['나무', '불', '흙', '쇠', '물']
  const labels = ['나무', '불', '흙', '쇠', '물']
  return input.map((val, i) => ({
    id: ids[i],
    label: labels[i],
    value: val,
    color: colors[i],
  }))
}
